import Paper from "@mui/material/Paper";
import { theme } from "../styles/theme";

export default function MapMenuType({ children, type }) {
  switch (type) {
    case "Filter":
      return (
        <Paper
          sx={{
            transform: "translate(66px, -8px)",
            width: "calc(100vw - 2rem)",
            marginRight: "0.75rem",
            marginTop: "-0.25rem",
            [theme.breakpoints.up("sm")]: {
              width: "24rem",
              transform: "unset",
            },
            [theme.breakpoints.up("lg")]: {
              width: "32rem",
            },
          }}
        >
          {children}
        </Paper>
      );
    case "Legende":
      return (
        <Paper
          sx={{
            transform: "translate(66px, -54px)",
            width: "calc(100vw - 2rem)",
            marginRight: "0.75rem",
            marginTop: "-0.25rem",
            maxHeight: "20rem",
            overflowY: "scroll",
            [theme.breakpoints.up("sm")]: {
              width: "16rem",
              transform: "unset",
            },
            [theme.breakpoints.up("md")]: {
              overflowY: "unset",
              maxHeight: "unset",
              width: "16rem",
            },
          }}
        >
          {children}
        </Paper>
      );
    default:
      return null;
  }
}
